import { useEffect, useState } from 'react';

import { useRef } from 'react';
import useOnScreen from '../hooks/UseOnScreen.js';

const News = () => {
	const instagramRef = useRef();
	const isInstaVisible = useOnScreen(instagramRef);
	const [loaded, setLoaded] = useState(false);

	/*useScript('https://app.taggshop.io/js/embed.min.js');*/

	useEffect(() => {
		if (isInstaVisible && !loaded) {
			const script = document.createElement('script');

			script.src = 'https://app.taggshop.io/js/embed.min.js';
			script.async = true;

			document.body.appendChild(script);
			setLoaded(true);
		}
		//return () => {
		//    document.body.removeChild(script);
		//}
	}, [isInstaVisible]);

	const content = (
		// eslint-disable-next-line react/no-unknown-property
		<div className="taggbox-socialwall" data-wall-id="109475" view-url="https://app.taggshop.io/s/109475"></div>
	);

	return (
		<>
			<div className="homepage-insta" ref={instagramRef}>
				{(isInstaVisible || loaded) && (
					<>
						<div className="content-wrapper">
							<div className="title flex-col">
								<h1>Inspiration from Instagram</h1>
							</div>
						</div>
						<div className="taggbox-container">{content}</div>
					</>
				)}
			</div>
		</>
	);
};

export default News;
